<template lang="pug">
	div(v-on:mousedown="isFocus = true" v-pseudo-modal-name="'json-editor'")
		v-jsoneditor(v-model="json" :options="options")
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Settings } 		from './../../../services/Settings';

	import VJsoneditor 			from 'v-jsoneditor';

	export default {
		name: "JsonEditControl",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Selected Version Settings Loaded", "Selected Version Settings Original Loaded"],
			events: {
				"Pseudo Modal Process Hide": function(els) {

					if (!_.includes(els, 'json-editor') && this.isFocus) {

						this.isFocus = false;

						this.update();

					}

				}
			}
		},
		components: {
			VJsoneditor
		},
		props: ['setting'],
		data() {

			return {
				showed: true,
				isFocus: false,
				json: Settings.getSettingValue(this.setting.codename),
				options: {
					onChange: this.onChange,
					mode: 'code'
				}
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии проекта
			let eventName = `Selected Version Setting Changed:${this.setting.codename}`;
			let eventKey = `vue-component-update-on-${this._uid}-${this.$options.name}`;

			Broadcast.on(eventName, (...params) => {

				if (!this.isFocus) this.update(eventName, ...params);

			}, eventKey);

			this.$once('hook:beforeDestroy', () => {

				Broadcast.off(eventName, eventKey);

			});

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('JsonEditControl collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.json = Settings.getSettingValue(this.setting.codename);

			},
			onChange() {

				Settings.setSettingValue(this.setting.codename, this.json);

			}
		}
	}
</script>

<style lang="sass">

	.jsoneditor
		background: #fff


</style>
